import {
  filter,
  map,
  mergeDeepRight,
  find,
  all,
  any,
  prop
} from 'ramda';
import questionTypes from '../questions/questionTypes.json';
import validateNumber from './validators/validateNumber';
import {
  hasNoAnswers,
  generateError,
  generateSuccess
} from './validators/validationHelpers';

const validators = {};
validators[questionTypes.range] = validateNumber;
validators[questionTypes.yesNo] = validateMultipleChoice;
validators[questionTypes.multipleChoice] = validateMultipleChoice;
validators[questionTypes.multipleAnswer] = validateMultipleAnswer;
validators[questionTypes.number] = validateNumber;
validators[questionTypes.text] = validateText;
validators[questionTypes.weight] = validateNumber;
validators[questionTypes.height] = validateNumber;

export default function validateAnswers(questions, answers) {
  const newQuestions = map(question => {
    const questionAnswers = filter(filterAnswers(question), answers);

    return validators[question.type](question, questionAnswers);
  }, questions);

  return {
    questions: newQuestions,
    valid: all(prop('valid'))(newQuestions)
  };
}

const generateBaseErrorOutcome = (answers, errorMessage) => {
  if (hasNoAnswers(answers)) {
    return generateError(errorMessage);
  } else {
    return null;
  }
};

export function validateMultipleChoice(question, answers) {
  const errorMessage = 'Please select an option for this question';
  const outcome = generateBaseErrorOutcome(answers, errorMessage);
  return mergeDeepRight(question, outcome || generateSuccess());
}

export function validateMultipleAnswer(question, answers) {
  const errorMessage = 'Please select at least one option for this question';
  let outcome = generateBaseErrorOutcome(answers, errorMessage);

  if (!outcome) {
    const selectedExclusiveAnswer = getSelectedExclusiveAnswer(answers, question);

    if (
      selectedExclusiveAnswer &&
        answers.length > 1
    ) {
      outcome = generateError(
        `Cannot select other options when selecting '${selectedExclusiveAnswer.text}'`
      );
    }
  }

  return mergeDeepRight(question, outcome || generateSuccess());
}

export function validateText(question, answers) {
  let outcome = null;
  const errorText = 'Please provide an answer to the question';
  if (hasNoAnswers(answers) || answers[0].value.length === 0) {
    outcome = generateError(errorText);
  }

  return mergeDeepRight(question, outcome || generateSuccess());
}

export function getSelectedExclusiveAnswer(answers, question) {
  const exclusiveAnswers = filter(answer => answer.exclusive)(question.options);
  if (!exclusiveAnswers || !exclusiveAnswers.length) {
    return null;
  }

  return find(
    exclusiveAnswer =>
      any(
        answer =>
          answer.answerId === exclusiveAnswer.answerId,
        answers),
    exclusiveAnswers);
}

export function filterAnswers(question) {
  return answer => question.questionId === answer.questionId;
}




// WEBPACK FOOTER //
// ./src/components/questionnaire/validateAnswers.js